module.exports = __webpack_public_path__ + "img/egdc.6559738f.png";